import { ConfigBackEndModel } from "../model/agro.contexto.model";
import { Injectable } from '@angular/core';


@Injectable()
export class ModelContext {

    private _contextos: ConfigBackEndModel[];

    constructor() {
        this._contextos = [];
    }

    /**
     * Adiciona um novo Contexto. 
     */
    public addContext(config: ConfigBackEndModel): void {
        this._contextos.push(config);
    }

    /**
     * Captura o contexto na aplicação.
     */
    public getContext(nameContext: string): string {

        let contexto = ""

        for (let i = 0; i < this._contextos.length; i++) {
            if (nameContext === this._contextos[i].getNameContext()) {
                contexto = this._contextos[i].getContextAPI();
                break;
            }
        }

        return contexto;
    }
}